// SSO OAuth (Google / Facebook / Apple) — démarrage du flux côté web.
// POST /api/auth/oauth/{provider}/start → { authorization_url, state }.
// Le navigateur est ensuite redirigé vers l'URL du fournisseur ; le retour se
// fait sur la page de callback web qui POST /callback {code,state}.

import { apiRequest } from '@/lib/api/client';

export type OAuthProvider = 'google' | 'facebook' | 'apple';

export async function startOAuth(provider: OAuthProvider): Promise<{ authorization_url: string; state: string }> {
  return apiRequest<{ authorization_url: string; state: string }>(`/api/auth/oauth/${provider}/start`, {
    method: 'POST',
    body: {},
  });
}

// POST /api/auth/oauth/{provider}/callback — le backend établit la session web
// (cookie) puis renvoie l'utilisateur. On ignore les tokens Bearer (flux mobile).
export interface OAuthCallbackPayload {
  state: string;
  code?: string;
  access_token?: string;
  locale?: string;
}

export async function completeOAuth(provider: OAuthProvider, payload: OAuthCallbackPayload): Promise<void> {
  await apiRequest<unknown>(`/api/auth/oauth/${provider}/callback`, { method: 'POST', body: payload });
}
